module.exports = __webpack_public_path__ + "static/img/shoe-zoom-title1.929ae8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/result/shoe-zoom-title1.png
// module id = 187
// module chunks = 1